import { Item } from './helpers/types'

export function dataLayerAddToCart(item: Item) {
  if (!item) {
    return
  }

  if (window['dataLayer']) {
    window['dataLayer'].push({ ecommerce: null })

    window['dataLayer'].push({
      event: 'add_to_cart',
      ecommerce: {
        items: [item],
      },
    })
  }
}
